import type { ModularBilling2026SubscriptionAccessResponseBodyType } from "@intelligems/ig-types";
import { useGetOrg } from "@src/api/organizations/get-organization";
import { billingModulesKeys } from "@src/api/queryKeys";
import { useQuery } from "@tanstack/react-query";

import type { QueryOptions } from "../../types/react-query";
import { api } from "../api";

export const getBillingSubscriptionAccess =
  async (): Promise<ModularBilling2026SubscriptionAccessResponseBodyType> => {
    const resp =
      await api.get<ModularBilling2026SubscriptionAccessResponseBodyType>(
        "/v3/billing/subscription-access"
      );

    return resp.data;
  };

export const useGetBillingSubscriptionAccess = (
  options?: QueryOptions<
    ModularBilling2026SubscriptionAccessResponseBodyType,
    Error
  >
) => {
  const org = useGetOrg();

  return useQuery<ModularBilling2026SubscriptionAccessResponseBodyType, Error>({
    ...options,
    queryKey: billingModulesKeys.subscriptionAccess(org.data.org.id),
    queryFn: getBillingSubscriptionAccess,
  });
};
